import config from './config.json'
import http from './httpService'

export const getDataLoginFromDB = page => {
    return http.get(`${config.coinbaseapi}/logins${page?`?page=${page}`:''}`)
}